module.exports = __webpack_public_path__ + "1b98819eb371ab8889627318ddeaed80.svg";